<template>
  <span>
    <dots-menu
      :items="saveDotsMenus"
      v-on="
        saveDotsMenus.reduce(
          (acc, menu) => ({
            ...acc,
            [menu.name]: () => save(menu.name),
          }),
          {}
        )
      "
    >
      <template #activator="{ on }">
        <v-tooltip color="font" bottom>
          <template #activator="{ on: onTooltip }">
            <span v-on="{ ...onTooltip }">
              <v-icon v-on="{ ...on }" color="primary" tag="button"> mdi-content-save </v-icon>
            </span>
          </template>
          {{ tooltip }}
        </v-tooltip>
      </template>
    </dots-menu>
    <copy-features-dialog
      v-if="isCopyObjectsGeometryLoaded !== null"
      :is-visible.sync="isCopyObjectsGeometryLoaded"
      :is-loading.sync="isCopyObjectGeometryLoading"
      v-bind="{ ...copyDialogProps, geojson }"
    />
  </span>
</template>

<script>
import { saveGeometryToFile } from '@/assets/js/mapUtils';
import DotsMenu from '@/components/DotsMenu';
import CopyFeaturesDialog from '@/components/CopyFeaturesDialog';

export default {
  name: 'SaveGeometryTrigger',
  components: {
    DotsMenu,
    CopyFeaturesDialog,
  },
  props: {
    actions: {
      type: Array,
      default: () => ['geojson', 'kml', 'copy'],
      validator: actions => actions.every(action => ['geojson', 'kml', 'copy'].includes(action)),
    },
    /** E.g.: {
     *  actionName: {
     *    customName: '...',
     *    action: () => {}
     * }
     */
    additionalActions: {
      type: Object,
      default: () => ({}),
    },
    tooltip: {
      type: String,
    },
    filename: {
      type: String,
    },
    geojson: {
      type: Object,
      required: true,
    },
    copyDialogProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isCopyObjectsGeometryLoaded: null,
    isCopyObjectGeometryLoading: false,
  }),
  computed: {
    saveDotsMenus() {
      const defaultMenus = [
        { name: 'geojson', customName: this.$i18n.t('menu.toGeojsonFile') },
        { name: 'kml', customName: this.$i18n.t('menu.toKmlFile') },
        { name: 'copy', customName: this.$i18n.t('menu.copyToLayer') },
      ];
      return [
        ...defaultMenus.filter(menu => this.actions.includes(menu.name)),
        ...Object.entries(this.additionalActions).map(([actionName, props]) => {
          // eslint-disable-next-line
          const { action, ...data } = props;
          return {
            ...data,
            name: actionName,
          };
        }),
      ];
    },
  },
  methods: {
    save(type) {
      switch (type) {
        case 'kml':
        case 'geojson':
          return saveGeometryToFile(type, this.filename, this.geojson);
        case 'copy':
          return (this.isCopyObjectsGeometryLoaded = true);
        default:
          return this.additionalActions[type]?.action(type);
      }
    },
  },
};
</script>
